import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { usuarioService } from '../services/usuarioService'
import { RolApp } from '../types/auth'

const USUARIOS = ['usuarios']

export function useUsuarios() {
  return useQuery({ queryKey: USUARIOS, queryFn: usuarioService.lista })
}

export function useRegistrarUsuario() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: usuarioService.registrar, onSuccess: () => qc.invalidateQueries({ queryKey: USUARIOS }) })
}

export function useCambiarUsuario() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...datos }: { id: number; activo?: boolean; es_staff?: boolean; roles?: RolApp[] }) => usuarioService.cambiar(id, datos),
    onSuccess: () => qc.invalidateQueries({ queryKey: USUARIOS }),
  })
}
